import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <Logo height={44} />
              <span className="footer-logo-text">Avika Ventures</span>
            </div>
            <p className="footer-desc">
              Empowering businesses with innovative software solutions and modern web development services.
            </p>
            <div className="footer-social">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Twitter">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
              </a>
            </div>
          </div>

          <div className="footer-links-group">
            <h4 className="footer-links-title">Services</h4>
            <Link to="/services" className="footer-link">Website Development</Link>
            <Link to="/services" className="footer-link">Software Development</Link>
            <Link to="/services" className="footer-link">Mobile Apps</Link>
            <Link to="/services" className="footer-link">AI & Automation</Link>
            <Link to="/services" className="footer-link">Cloud & DevOps</Link>
          </div>

          <div className="footer-links-group">
            <h4 className="footer-links-title">Company</h4>
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
            <Link to="/work-with-us" className="footer-link">Work With Us</Link>
          </div>

          <div className="footer-links-group">
            <h4 className="footer-links-title">Projects</h4>
            <a href="https://saatsaheli.com" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <img src="/saatsaheli-logo.png" alt="SaatSaheli" style={{ width: 20, height: 20, borderRadius: 4 }} />
              SaatSaheli.com
            </a>
          </div>

          <div className="footer-links-group">
            <h4 className="footer-links-title">Contact</h4>
            <a href="mailto:contact@avikaventures.com" className="footer-link">contact@avikaventures.com</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Avika Ventures. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
